import { themeUi } from '../../themeUi/themeUi';

const loginMigrations = {
  redisBackground: {
    color: themeUi.semantic.color.text.neutral100
  }
};

export default loginMigrations;
